import { Injectable } from '@angular/core';
//import java.io.IOExpection;
import { HttpHeaders } from '@angular/common/http';
import { ApiRestService } from './api-rest.service';
import { HttpClient, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import { map, Observable } from 'rxjs';

const API_URL = "/upload";
const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};


@Injectable({
  providedIn: 'root'
})
export class FileService {
  //private baseUploadApiUrl_sbbcpolicy = 'https://localhost:7191/api/fileupload';
  private baseUploadApiUrl_sbbcpolicy = 'https://web01cdev.browardschools.local/bcpswebapiinternal/api/fileupload';
  private basePDFStreamApiUrl_sbbcpolicy = 'https://web01cdev.browardschools.local/bcpswebapi/api/schoolboardpolicies';
  constructor(private apiRestService : ApiRestService, private httpClient: HttpClient) { }

  FileUpload(theFile) {
    var fileFormat;

    this.apiRestService.uploadFile(API_URL, theFile, fileFormat);
    return "file uploaded";
  }

  public uploadFile(file: Blob): Observable<HttpEvent<void>> {
    const formData = new FormData();
    formData.append('file', file);
    return this.httpClient.request(new HttpRequest(
      'POST',
      this.baseUploadApiUrl_sbbcpolicy + API_URL,
      formData,
      // {
      //   reportProgress: true
      // }
      ));
  }

  public upload(file: Blob) {
    const formData = new FormData();
    formData.append('file', file);
    return this.apiRestService.uploadFile(API_URL, file, formData);
  }

  public getPDFFileStream(apiCall, fileName) {
    return this.apiRestService.getPDFStream(apiCall);
  }

  public getPDFFileStream_CharterSchool(apiCall, fileName) {
    return this.apiRestService.getPDFStream_CharterSchool(apiCall);
  }
}
